import {
  InsuranceDetails,
  postManualInsuranceCancelRequest,
} from 'Api/insurance';

import { AgreementCode } from 'Constants/agreementCodes.constants';
import {
  DANSKE_BANK_PHONE_NUMBER,
  STOREBRAND_PHONE_NUMBER,
} from '../../../constants/phoneNumbers.constants';
import { isMigratedDanskeBankAgreement } from '../../../utils/agreementCodes/agreementCodes.utils';
import { EmailCancellationFormValues } from './emailCancellationForm.values';

export const getPartnerPhoneNumberVariable = (
  agreementProduct: AgreementCode,
): Record<string, string | number> => {
  const migratedDanskeBankPhoneLink = {
    linkText: DANSKE_BANK_PHONE_NUMBER.telString,
    href: DANSKE_BANK_PHONE_NUMBER.href,
  };
  const defaultPhoneLink = {
    linkText: STOREBRAND_PHONE_NUMBER.telString,
    href: STOREBRAND_PHONE_NUMBER.href,
  };

  return isMigratedDanskeBankAgreement(agreementProduct)
    ? migratedDanskeBankPhoneLink
    : defaultPhoneLink;
};

export const submitEmailCancellationForm = async (
  values: EmailCancellationFormValues,
  insuranceDetails: InsuranceDetails,
  setSubmitError: React.Dispatch<React.SetStateAction<boolean>>,
  setSubmitSuccess: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  const { organizationPillar, policyNumber } = insuranceDetails;

  try {
    setSubmitError(false);

    await postManualInsuranceCancelRequest(
      values.manualMessage,
      organizationPillar,
      policyNumber,
    );

    setSubmitSuccess(true);
  } catch {
    setSubmitError(true);
  }
};
